import React from 'react';

export const CustomModal: React.FC<{}> = (props: any) => (
  <div className="search-email-modal ">
    <section className="search-email-modal-main">{props.children}</section>
  </div>
);
CustomModal.displayName = 'CustomModal';
export default CustomModal;
